var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 860.6 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #86cfea;\n      }\n\n      .cls-1, .cls-2 {\n        isolation: isolate;\n      }\n\n      .cls-2 {\n        fill: #bee5f5;\n      }\n\n      .cls-3 {\n        fill: #189cd7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.7,472.5L22.3,286.4c-29.9-17.5-29.6-60.7.4-77.8L348.7,22.8c50.9-29.1,113.4-29.1,164.3,0l325,185.1c30.2,17.2,30.2,60.9,0,78.1l-331.8,187.6c-50.9,28.8-115,28.4-165.4-1.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M838,461.2l-111.6-63.6-220.3,124.6c-50.9,28.8-115,28.4-165.4-1.1l-208.3-121.7-109.8,62.5c-30,17.1-30.2,60.3-.4,77.7l318.5,186.2c50.4,29.5,114.5,29.8,165.4,1.1l331.8-187.6c30.2-17.2,30.3-60.8,0-78.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M838,712l-110.1-62.7-221.8,125.4c-50.9,28.8-114.9,28.4-165.4-1.1l-209.8-122.6-108.3,61.7c-30,17.1-30.2,60.3-.4,77.7l318.5,186.2c50.4,29.5,114.5,29.8,165.4,1.1l331.8-187.6c30.2-17.2,30.3-60.8,0-78.1h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1756e86aa9a01cb256a2642a777b1039.svg";
export { ForwardRef as ReactComponent };